// Single-point elevation (still calls OpenTopoData directly – use for backend or quick tests)
export async function getElevationAtPoint(lat, lng) {
  const url = `https://api.opentopodata.org/v1/srtm90m?locations=${lat},${lng}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Elevation API failed');
  const data = await res.json();
  if (data.status !== 'OK' || !data.results || !data.results[0]) {
    throw new Error('No elevation result');
  }
  return data.results[0].elevation; // in meters
}

// Elevation grid via your backend proxy to avoid CORS
export async function getElevationGrid(centerLat, centerLng, size = 0.002, samples = 8) {
  const params = new URLSearchParams({
    lat: centerLat,
    lng: centerLng,
    size: String(size),
    samples: String(samples),
  });

  const res = await fetch(`/api/elevation-grid?${params.toString()}`);
  console.log('proxy status', res.status);
  if (!res.ok) throw new Error('Elevation grid API failed (proxy)');

  const data = await res.json();
  console.log('proxy data status', data.status, 'results', data.results?.length);
  if (data.status !== 'OK' || !data.results || !data.results.length) {
    throw new Error('No elevation grid results');
  }

  return data.results.map((r) => ({
    x: r.location.longitude,
    y: r.location.latitude,
    z: r.elevation,
  }));
}